// extracted by mini-css-extract-plugin
export default {"changeLink":"CS-z","disabled":"DS-z","inline":"ES-z"};